import type { EditorPluginOptions } from './../../ricos-common-plugins/types';
import type { EditorPlugin } from './../../ricos-types';

export const isEditorPlugin = (
  pluginOrConfig: EditorPlugin | EditorPluginOptions
): pluginOrConfig is EditorPlugin => {
  return 'tiptapExtensions' in pluginOrConfig;
};

export const isEditorPluginOptions = (
  pluginOrConfig: EditorPlugin | EditorPluginOptions
): pluginOrConfig is EditorPluginOptions => {
  return !('tiptapExtensions' in pluginOrConfig);
};
